export default __webpack_public_path__ + "static/media/330_dummy2016-pragentur01-de.bb3a44f4.png";